import {CircularProgress} from '@material-ui/core';
import EnrollmentApplicationForm from 'Agent/Accounts/components/EnrollmentApplication/EnrollmentApplicationForm';
import 'Agent/Accounts/components/EnrollmentApplication/EnrollmentApplicationModal.sass';
import {clearApplication} from 'Agent/Accounts/ducks/enrollmentApplication';
import {
  EnrollmentApplicationWithError,
  InvalidEnrollmentApplication,
  matchEnrollmentApplication,
  ValidEnrollmentApplication,
} from 'Agent/Accounts/models/EnrollmentApplication';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import Modal from 'Shared/components/Modal';

type EnrollmentApplicationModalProps = {
  hideModal: () => void;
  accountNumber: string;
  accountId: string;
  servicingAgentNumber?: string;
};

export const EnrollmentApplicationModal = (props: EnrollmentApplicationModalProps) => {
  const dispatch = useDispatch();
  const {application} = useSelector((state: ReducerState) => state.enrollmentApplication);
  const resetApplication = () => {
    dispatch(clearApplication());
  };

  useEffect(() => resetApplication, []);

  const renderApplicationForm = (
    application: EnrollmentApplicationWithError | InvalidEnrollmentApplication | ValidEnrollmentApplication
  ) => (
    <EnrollmentApplicationForm
      accountId={props.accountId}
      onCancel={props.hideModal}
      servicingAgentNumber={props.servicingAgentNumber}
      accountNumber={props.accountNumber}
      application={application}
    />
  );

  return (
    <Modal title="Upload Enrollment Application" open onClose={props.hideModal} disableBackdropClick>
      {matchEnrollmentApplication(application, {
        EnrollmentApplicationWithError: renderApplicationForm,
        InvalidEnrollmentApplication: renderApplicationForm,
        ValidEnrollmentApplication: renderApplicationForm,
        SavingEnrollmentApplication: () => (
          <div className="upload-enrollment-application__loading-container">
            <CircularProgress />
          </div>
        ),
      })}
    </Modal>
  );
};

export default EnrollmentApplicationModal;
